import styled, { css } from 'styled-components';
import { Item as IT } from '../styles';

export const ItemsWrapper = styled.div`
  @media (min-width: 771px) {
    display: none;
  }
  position: relative;
  width: 100%;
  height: 84px;
`;

export const Items = styled.div`
  @media (min-width: 771px) {
    display: none;
  }
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 20%,
    rgba(255, 255, 255, 0) 21%
  );
  height: 84px;
  display: flex;
  align-items: inherit;
  width: 100%;
  margin: 0;
  flex-direction: row;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

export const Item = styled(IT)`
 @media (min-width: 771px) {
    display: none;
  }
  margin:0;
  padding-top: 4px;
  width:100%;
  height:100%;
  min-height:100%;

    ${({ selected }) =>
      selected
        ? css`
            background: #fff;
            border-radius: 0 0 16px 16px;
            padding: 8px;
          `
        : css`
            background: #000fff;
          `};
    ${({ next }) =>
      next &&
      css`
        border-top-left-radius: 16px;
      `}
    ${({ previous }) =>
      previous &&
      css`
        border-top-right-radius: 16px;
      `}
  }

  div img.lapidar {
      @media (max-height: 610px) {
        width: 26px;
        height: 23px;
      }
  }
  div {
    height:64px;
    display: flex;
    margin: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 6px;
    padding-top:10px;
    span{
        font-size:12px;
        width: 65px;

      }

    img {
      z-index: 898;
      margin-bottom: 4px;
        width: 32px;
        height: 28px;

      @media (max-height: 610px) {
        width: 26px;
        height: 23px;
      }

      @media (min-width: 771px) {
        width: 32px;
        height: 28px;
      }
    }
    img.job-control {

        width: 32px;
        height: 28px;
        padding-bottom: 0.1rem;

    }
    img.lapidar {

        width: 32px;
        height: 28px;

      @media  (max-height: 610px) {
        width: 26px;
        height: 23px;
      }
    }

    z-index: 898;
    display: ${props => (props.onlyDesktopItem ? 'none' : 'flex')};
    position: relative;
    width: ${props => (props.width ? props.width : 'auto')};
    min-width: 80px;
    flex-shrink: 0;


    div > span {
      font-size: 12px;
      line-height: 11px;
      height: 22px;

      @media (max-height: 580px){
        font-size:9px;
      }
    }
    @media (max-width:396px){
      img{
        width:25px;
        height:21px;
      }
      span{
        font-size:9px;
        width: 50px;

      }
    }
  }

  @media  (max-height: 580px) {
    height: 3.5rem;

      span{
        font-size:9px;
      }


  }

  @media (min-height: 790px) {
    height: 5rem;
  }
`;

export const BorderedDetail = styled.div`
  @media (min-width: 771px) {
    display: none;
  }
  height: 25px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 70%,
    rgba(0, 15, 255, 1) 85%
  );

  div {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 50%,
      rgba(255, 255, 255, 1) 65%
    );

    ${({ selected }) =>
      selected === 'Universidade Ultragaz'
        ? css`
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 16px;
          `
        : selected === 'Início'
        ? css`
            border-bottom-right-radius: 16px;
            border-bottom-left-radius: 0px;
          `
        : css`
            border-bottom-right-radius: 16px;
            border-bottom-left-radius: 16px;
          `}
    height: 27px;
    transform: translateY(-1px);
  }
`;

export const ScrollArrow = styled.div`
  position: absolute;
  right: 12px;
  bottom: 10%;
  transform: translateY(50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 20;
  @media (min-width: 771px) {
    display: none !important;
  }
`;

export const ScrollArrowLeft = styled.div`
  position: absolute;
  left: 12px;
  bottom: 10%;
  transform: translateY(50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 20;
  @media (min-width: 771px) {
    display: none !important;
  }
`;
